<a id="userDisplay" [ngStyle]="{color: color}" (click)="onToggleMenu($event)">
  <span class="username">{{ username }}</span>
  <span nz-icon nzType="icons/fontawesome/regular:user-circle" class="user-icon"></span>
  <i nz-icon nzType="icons/fontawesome/solid:angle-down"></i>
  <div id="topbar-menu" class="fadeInDown" [ngClass]="getStyleClass()">
    <div class="profile-detail">
      <span>{{ username }}</span>
    </div>
    <ng-content></ng-content>
  </div>
</a>
